import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";

import Checkbox from "../../../atoms/input/checkbox";
import GrayBtn from "../../../atoms/button/grayBtn";
import PretendardText from "../../../atoms/text/pretendardText";
import MemberApi from "../../../../api/member.api";
import { toast } from "react-toastify";
import { toastMsg } from "../../../../util/toastMsg";
import { errorHandler } from "../../../../util/errorHandler";
import SelectBoxValue from "../../selectBoxValue";
import CouponApi from "../../../../api/coupon.api";

const CouponGive = ({
  userCheckedIdList,
  getMemberList,
  sessionStorageInit,
  setButtonGroupOpen,
  setButtonGroupFilterOpen,
}) => {
  const navigate = useNavigate();
  const [alarmFlag, setAlarmFlag] = useState(false);

  const [couponList, setCouponList] = useState([]);

  // 쿠폰 지급 관련
  const [couponBoxOpen, setCouponBoxOpen] = useState(false);
  const [selectedCoupon, setSelectedCoupon] = useState("");

  useEffect(() => {
    getCouponList();
  }, [userCheckedIdList]);

  //  상품 카테고리 가져오기
  const getCouponList = async () => {
    try {
      const data = {
        page: 1,
        size: 0,
        activation: "Active",
        couponType: "ASIGN",
      };

      const response = (await CouponApi.getList(data)).data.data.content;

      let temp = response.map((item) => {
        return {
          value: item.id,
          title: item.title,
        };
      });

      setCouponList(temp);
    } catch (error) {
      errorHandler(error);
    }
  };

  const couponGiveFunc = async () => {
    try {
      let memberIdsTemp = userCheckedIdList.map((item) => item.id);

      const data = {
        memberIds: memberIdsTemp,
        couponId: Number(selectedCoupon),

        alarmFlag: alarmFlag,
      };

      await MemberApi.memberCoupon(data);
      getMemberList();
      toast(toastMsg.create);
      setButtonGroupOpen(false);
      sessionStorageInit();
    } catch (error) {
      errorHandler(error);
    }
  };

  return (
    <>
      <FilterWrapper
        style={{
          width: 370,
          top: 36,
          padding: 16,
        }}
      >
        <FilterTitle
          style={{
            marginBottom: 10,
          }}
        >
          지급할 쿠폰
        </FilterTitle>
        <SelectBoxValue
          placeholder={"쿠폰 선택"}
          selectedValue={selectedCoupon}
          isOpen={couponBoxOpen}
          wrapperHandler={() => {
            setCouponBoxOpen(!couponBoxOpen);
          }}
          itemList={couponList}
          selectedValueSetterFunc={setSelectedCoupon}
        />
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            margin: "12px 0px 16px 0px",
            gap: 12,
          }}
        >
          <CheckboxWrapper
            onClick={() => {
              setAlarmFlag(!alarmFlag);
            }}
          >
            <Checkbox
              checked={alarmFlag}
              onChange={() => {
                setAlarmFlag(!alarmFlag);
              }}
            />
            <CheckboxText
              style={{
                fontSize: "15px",
                fontWeight: "500",
                lineHeight: "21.5px",
                color: "#aaa",
              }}
            >
              알림 전송하기
            </CheckboxText>
          </CheckboxWrapper>
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            gap: 8,
          }}
        >
          <GrayBtn
            style={{
              backgroundColor: "#313233",
            }}
            onClick={() => {
              setButtonGroupFilterOpen((prev) => ({
                ...Object.keys(prev).reduce(
                  (acc, key) => ({ ...acc, [key]: false }),
                  {}
                ),
                coupon: !prev.coupon,
              }));
            }}
          >
            취소
          </GrayBtn>
          <GrayBtn
            style={{
              backgroundColor: "#313233",
            }}
            onClick={() => {
              if (selectedCoupon === "") {
                toast("쿠폰을 선택해주세요.");
                return;
              }

              couponGiveFunc();

              setButtonGroupFilterOpen({
                group: false,
                gradeAndLevel: false,
                point: false,
                coupon: false,
                read: false,
                write: false,
              });
            }}
          >
            지급하기
          </GrayBtn>
        </div>
      </FilterWrapper>
    </>
  );
};

export default CouponGive;

const FilterWrapper = styled.div.attrs((props) => {})`
  padding: 10px;
  border-radius: 3px;
  background: #272829;
  box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.25);
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 48px;
  z-index: 5;
`;

const FilterTitle = styled(PretendardText).attrs((props) => {})`
  font-weight: 500;
  font-size: 13px;
  line-height: 18.75px;
  color: #aaa;
`;

const CheckboxWrapper = styled.div.attrs((props) => {})`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const CheckboxText = styled(PretendardText).attrs((props) => {})`
  font-size: 15px;
  font-weight: 500;
  line-height: 21.5px;
  color: #aaa;

  cursor: pointer;
`;
